import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Accordion, Icon, Image, Label, Message, Step, Table, Segment, Modal, Button, Header, Form, Feed, Popup } from 'semantic-ui-react';
import moment from 'moment';
import { imageURI, bankslipURI, storageURI, OrderStatus, metaToString, capitalizeKey } from '../config';
import { processOrder, cancelOrder, addNote, uploadBankSlip, getHolidays } from '../actions';

const courierOptions = [
    { key: 'Self Collect', text: 'Self Collect', value: 'Self Collect' },
    // { key: 'Pos Laju', text: 'Pos Laju', value: 'Pos Laju'},
    { key: 'J&T Express', text: 'J&T Express', value: 'J&T Express' }
]

const trackingURL = 'https://www.tracking.my/jt/';

class OrderDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cartOpen: true,
            logOpen: false,
            orderID: -1,
            addNoteDialog: false,
            processDialog: false,
            cancelDialog: false,
            paymentChecked: false,
            paymentMethod: 'Bank In',
            paymentReference: '',
            shipmentCourier: 'J&T Express',
            shipmentTracking: '',
            cancellationNote: '',
            miscNote: ''
        }
        window.Handlebars.registerHelper('ifEquals', function (arg1, arg2, options) {
            return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
        });
        window.Handlebars.registerHelper('currency', function (value) {
            return value.toFixed(2);
        });
        window.Handlebars.registerHelper('date', function (date) {
            return moment(date).format('DD-MM-YYYY');
        });
        window.Handlebars.registerHelper('math', function(lvalue, operator, rvalue, options) {
            lvalue = parseFloat(lvalue);
            rvalue = parseFloat(rvalue);

            return {
                "+": lvalue + rvalue,
                "-": lvalue - rvalue,
                "*": lvalue * rvalue,
                "/": lvalue / rvalue,
                "%": lvalue % rvalue
            }[operator];
        });
        
        window.Handlebars.registerHelper('showKey', function (value) {
            const capitalize = text => text
                .split('_')
                .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                .join(' ');
            return capitalize(value);
        });
    }

    componentWillMount() {
        let order_id = this.props.match.params.order_id;
        let order = this.props.order.order_list.find((n) => n._id === order_id);
        if (order.payment) {
            let verified = (order.payment.verified_by !== null) && (order.payment.verified_at !== null);
            this.setState({ orderID: order_id, paymentMethod: order.payment.method, paymentReference: order.payment.reference, paymentChecked: verified });
            if (order.order_details.delivery_option === 'SELF COLLECT') {
                this.setState({ shipmentCourier: 'Self Collect' });
            }
        } else {
            this.setState({ orderID: order_id });
        }
        this.setState({ selectedOrder: order });
        console.log(order);
    }

    componentWillReceiveProps(nextProps) {
        let oldOrder = this.props.order.order_list.find((n) => n._id === this.state.orderID);
        let newOrder = nextProps.order.order_list.find((n) => n._id === this.state.orderID);
        if ((oldOrder.status === 'Processed') && (newOrder.status === 'Shipped')) {
            this.setState({ processDialog: false });
        } else if ((oldOrder.status !== 'Canceled') && (newOrder.status === 'Canceled')) {
            this.setState({ cancelDialog: false });
        } else if ((oldOrder.notes) && (oldOrder.notes !== newOrder.notes)) {
            this.setState({ addNoteDialog: false });
        } else if ((!oldOrder.notes) && (newOrder.notes)) {
            this.setState({ addNoteDialog: false });
        } else if ((!oldOrder.payment) && (newOrder.payment)) {
            this.setState({ paymentMethod: newOrder.payment.method, paymentReference: newOrder.payment.reference });
        }
    }

    handleCartClick() {
        this.setState({ cartOpen: !this.state.cartOpen });
    }

    handleLogClick() {
        this.setState({ logOpen: !this.state.logOpen });
    }

    handleAddNote() {
        this.setState({ addNoteDialog: true });
    }

    handleProcessOrder() {
        this.setState({ processDialog: true });
    }

    handleCancelOrder() {
        this.setState({ cancelDialog: true });
    }

    handleMiscNoteInput(e) {
        this.setState({ miscNote: e.target.value });
    }

    handlePaymentRefInput(e) {
        this.setState({ paymentChecked: false, paymentReference: e.target.value });
    }

    handleCourierInput(e, { value }) {
        this.setState({ shipmentCourier: value });
    }

    handleTrackingInput(e) {
        this.setState({ shipmentTracking: e.target.value });
    }

    handleCancellationNoteInput(e) {
        this.setState({ cancellationNote: e.target.value });
    }

    closeAddNoteDialog() {
        this.setState({ addNoteDialog: false });
    }

    closeProcessDialog() {
        this.setState({ processDialog: false });
    }

    closeCancelDialog() {
        this.setState({ cancelDialog: false });
    }

    submitNote() {
        this.props.addNote({
            orderID: this.state.orderID,
            user: this.props.user,
            note: this.state.miscNote
        });
    }

    handlePrintInvoice() {
        console.log(this.state.selectedOrder);
        let html = window.Handlebars.templates.invoice(this.state.selectedOrder);
        let strWindowFeatures = "`menu`bar=yes,location=no,resizable=no,scrollbars=yes,status=no";
        // window.open(window.location.hostname + ':' + window.location.port + html, "_blank", strWindowFeatures);
        let stmt_wnd = window.open("", "_blank");
        stmt_wnd.document.write(html);
    }

    handlePrintJobSheet() {
        console.log(this.state.selectedOrder);
        let html = window.Handlebars.templates.jobsheet(this.state.selectedOrder);
        let strWindowFeatures = "menubar=yes,location=no,resizable=no,scrollbars=yes,status=no";
        // window.open(window.location.hostname + ':' + window.location.port + html, "_blank", strWindowFeatures);
        let stmt_wnd = window.open("", "_blank");
        stmt_wnd.document.write(html);

    }

    onBankslipUpload = (e) => {
        e.stopPropagation();
        e.preventDefault();

        let files = e.target.files;
        console.log(e.target.files[0]);

        if (files) {
            this.props.uploadBankSlip({
                order_id: this.state.orderID,
                file: files[0],
                verifier: this.props.user
            });
        }
    }

    verifyPayment() {
        this.props.processOrder({
            orderID: this.state.orderID,
            processInput: {
                verifier: this.props.user,
                paymentReference: this.state.paymentReference
            }
        });

        this.setState({ paymentChecked: true });
    }

    sendOrder() {
        this.props.processOrder({
            orderID: this.state.orderID,
            processInput: {
                courier: this.state.shipmentCourier,
                tracking: this.state.shipmentTracking,
                shipper: this.props.user
            }
        });
    }

    cancelOrder() {
        this.props.cancelOrder({
            orderID: this.state.orderID,
            staff: this.props.user,
            note: this.state.cancellationNote
        });
    }

    calculateCompletionDate(orderDate, processDays) {
        console.log('calculateCompletionDate' + ': ' + orderDate + ',' + processDays);
        let holidays = this.props.holiday.list;
        let nextDate = moment(orderDate).startOf('day');
        let dayOfWeek = nextDate.day();
        for (let i=0; i<processDays; i++) {
            nextDate = nextDate.add(1, 'days');
            dayOfWeek = nextDate.day();
            let checkHoliday = holidays.some(function(holiday){ return  nextDate.format('DD-MM-YYYY') ===  moment(holiday._id).format('DD-MM-YYYY')});

            // Loop through every date for number of process days
            while(true) {
                if ( ((dayOfWeek > 0) && (dayOfWeek < 6)) && (!checkHoliday) ) break;
                nextDate = nextDate.add(1, 'days');
                dayOfWeek = nextDate.day();
                checkHoliday = holidays.some(function(holiday){ return  nextDate.format('DD-MM-YYYY') ===  moment(holiday._id).format('DD-MM-YYYY')});
                // console.log( "dayOfWeek" + dayOfWeek);
            }
            // console.log(nextDate.format('DD-MM-YYYY'));
            // console.log(dayOfWeek);
    }
        return (
            <p> {nextDate.format('DD-MM-YYYY')} </p>
        )
    }

    renderLogs(selectedOrder) {
        let logs = [];

        if (selectedOrder.payment) {
            let entry;
            if (selectedOrder.payment.method === 'In-Store Credit') {
                entry = {
                    time: selectedOrder.payment.date,
                    icon: 'money',
                    content: <Feed.Extra text>Payment made via <b>{selectedOrder.payment.method}</b></Feed.Extra>
                }
            } else {
                entry = {
                    time: selectedOrder.payment.verified_at,
                    icon: 'money',
                    content: <Feed.Extra text>Payment made via <b>{selectedOrder.payment.method}</b> with payment reference <b>{((selectedOrder.payment.provider === 'CustomerUpload' || selectedOrder.payment.provider === 'StaffUpload') ? <a href={bankslipURI + selectedOrder.payment.reference + '!full'} target='_blank'>{selectedOrder.payment.reference}</a> : selectedOrder.payment.reference)}</b> was verified by <b>{selectedOrder.payment.verified_by.name}</b></Feed.Extra>
                }
            }
            logs.push(entry);
        }

        if (selectedOrder.cancellation) {
            let entry = {
                time: selectedOrder.cancellation.canceled_at,
                icon: 'trash',
                content: <Feed.Extra text>Cancellation made by <b>{selectedOrder.cancellation.logged_by.name}</b> with note "<b>{selectedOrder.cancellation.note}</b>"</Feed.Extra>
            }
            logs.push(entry);
        }

        if (selectedOrder.shipment) {
            let entry;
            if (selectedOrder.shipment.courier === 'Self Collect') {
                entry = {
                    time: selectedOrder.shipment.updated_at,
                    icon: 'inbox',
                    content: <Feed.Extra text>Self collection was arranged by <b>{selectedOrder.shipment.shipped_by.name}</b></Feed.Extra>
                }
            } else {
                entry = {
                    time: selectedOrder.shipment.updated_at,
                    icon: 'truck',
                    content: <Feed.Extra text>Shipped via <b>{metaToString(selectedOrder.shipment.courier)}</b> with tracking number <a href={trackingURL + selectedOrder.shipment.tracking} target='_blank'><b>{selectedOrder.shipment.tracking}</b></a> was arranged by <b>{selectedOrder.shipment.shipped_by.name}</b></Feed.Extra>
                }
            }
            logs.push(entry);
        }

        if (selectedOrder.notes) {
            selectedOrder.notes.forEach((note) => {
                let entry = {
                    time: note.updated_at,
                    icon: 'file text outline',
                    content: <Feed.Extra text><b>{note.user.name}</b> added note with "<b>{note.note}</b>"</Feed.Extra>
                }
                logs.push(entry);
            });
        }

        let new_logs = _.sortBy(logs, ['time']);

        return new_logs.map((entry, index) => (
            <Feed key={index}>
                <Feed.Event>
                    <Feed.Label>
                        <Icon name={entry.icon} />
                    </Feed.Label>
                    <Feed.Content>
                        <Feed.Date>{moment(entry.time).format('DD/MM/YYYY HH:mm')}</Feed.Date>
                        {entry.content}
                    </Feed.Content>
                </Feed.Event>
            </Feed>
        ));
    }


    render() {
        const { logOpen, cartOpen, selectedOrder, paymentMethod, paymentReference, shipmentCourier, shipmentTracking, cancellationNote, miscNote, addNoteDialog, processDialog, cancelDialog, holidayDate } = this.state;
        const { order_list, upload_status } = this.props.order;
        let paymentChecked = false;
        if (selectedOrder.payment) {
            paymentChecked = (selectedOrder.payment.verified != null);
        }
        let enableSendButton = (paymentChecked && (shipmentCourier !== '') && !((shipmentCourier !== 'Self Collect') && (shipmentTracking === '')));

        let status_icon = '';
        let status_color = '';

        if (selectedOrder.status === 'Ordered') {
            status_icon = 'warning circle';
            status_color = 'orange';
        } else if (selectedOrder.status === 'Paid') {
            status_icon = 'add circle';
            status_color = 'olive';
        } else if (selectedOrder.status === 'Processed') {
            status_icon = 'check circle';
            status_color = 'teal';
        } else if (selectedOrder.status === 'Shipped') {
            status_icon = 'check circle';
            status_color = 'green';
        } else {
            status_icon = 'remove circle';
            status_color = 'red';
        }

        return (
            <div style={{ marginTop: '2em' }}>
                <Segment.Group>
                    <Segment>
                        <b>Order #{selectedOrder._id}</b>
                        <div style={{ float: 'right' }}>
                        <Popup
                                trigger={<Icon bordered className="clickable" name="clipboard list" onClick={this.handlePrintJobSheet.bind(this)}/>}
                                content='Print Job Sheet'
                                style={{opacity: 0.7}}
                                inverted
                            />
                            <Popup
                                trigger={<Icon bordered className="clickable" name="print" onClick={this.handlePrintInvoice.bind(this)}/>}
                                content='Print Invoice'
                                style={{opacity: 0.7}}
                                inverted
                            />
                            <Popup
                                trigger={<Icon className="clickable" bordered name='edit' onClick={this.handleAddNote.bind(this)}/>}
                                content='Add Note'
                                style={{opacity: 0.7}}
                                inverted
                            />
                        </div>
                    </Segment>
                    <Segment.Group horizontal>
                        <Segment>
                            <Icon name='payment' /><b>Transaction Details</b>
                            <Table basic='very' compact='very'>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell>Order Date</Table.Cell>
                                        <Table.Cell>{moment(selectedOrder.order_date).format('DD/MM/YYYY HH:mm')}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>Order Total</Table.Cell>
                                        <Table.Cell>RM {selectedOrder.order_details.total_amount.toFixed(2)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>Payment Date</Table.Cell>
                                        <Table.Cell>{(selectedOrder.payment) && moment(selectedOrder.payment.date).format('DD/MM/YYYY HH:mm')}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>Payment Method</Table.Cell>
                                        <Table.Cell>{(selectedOrder.payment) && selectedOrder.payment.method}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>Payment Reference</Table.Cell>
                                        <Table.Cell>{(selectedOrder.payment) && ((selectedOrder.payment.provider === 'CustomerUpload' || selectedOrder.payment.provider === 'StaffUpload') ? <a href={bankslipURI + selectedOrder.payment.reference + '!full'} target='_blank'>{selectedOrder.payment.reference}</a> : selectedOrder.payment.reference)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>Payment Verified</Table.Cell>
                                        <Table.Cell>{((selectedOrder.payment) && (selectedOrder.payment.verified)) && selectedOrder.payment.verified.name + ' @ ' + moment(selectedOrder.payment.verified.date).format('DD/MM/YYYY HH:mm')}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>Expected Completion</Table.Cell>
                                        <Table.Cell>{this.calculateCompletionDate(selectedOrder.order_date, selectedOrder.order_details.process_days)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>Shipment Date</Table.Cell>
                                        <Table.Cell>{(selectedOrder.shipment) && moment(selectedOrder.shipment.updated_at).format('DD/MM/YYYY HH:mm')}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>Shipment Tracking</Table.Cell>
                                        <Table.Cell>{(selectedOrder.shipment) && <a href={trackingURL + selectedOrder.shipment.tracking} target='_blank'>{selectedOrder.shipment.tracking}</a>}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>STATUS</Table.Cell>
                                        <Table.Cell>
                                            <Label color={status_color} size='large' image>
                                                <Icon name={status_icon} />
                                                {selectedOrder.status.toUpperCase()}
                                            </Label>
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>
                        <Segment>
                            <Icon name='address book' /><b>Billing Details</b><br /><br />
                            {selectedOrder.order_details.customer.name}<br />
                            {selectedOrder.order_details.customer.company}<br />
                            {selectedOrder.order_details.customer.address.address_1}<br />
                            {(selectedOrder.order_details.customer.address.address_2.length > 0) && selectedOrder.order_details.customer.address.address_2}<br />
                            {selectedOrder.order_details.customer.address.postcode} {selectedOrder.order_details.customer.address.town_city}<br />
                            {selectedOrder.order_details.customer.address.state}<br />
                            {selectedOrder.order_details.customer.address.country}<br />
                            <br />
                            <Icon name='phone' /><a href={'tel:' + selectedOrder.order_details.customer.phone}>{selectedOrder.order_details.customer.phone}</a><br />
                            <Icon name='mail' /><a href={'mailto:' + selectedOrder.order_details.customer.email}>{selectedOrder.order_details.customer.email}</a>
                        </Segment>
                        <Segment>
                            <Icon name='shipping' /><b>Shipping Details</b><br /><br />
                            {(selectedOrder.order_details.recipient)
                                ? (<div>
                                    {selectedOrder.order_details.recipient.name}<br />
                                    {selectedOrder.order_details.recipient.address.address_1}<br />
                                    {(selectedOrder.order_details.recipient.address.address_2.length > 0) && selectedOrder.order_details.recipient.address.address_2}
                                    {(selectedOrder.order_details.recipient.address.address_2.length > 0) && <br />}
                                    {selectedOrder.order_details.recipient.address.postcode} {selectedOrder.order_details.recipient.address.town_city}<br />
                                    {selectedOrder.order_details.recipient.address.state}<br />
                                    {selectedOrder.order_details.recipient.address.country}<br />
                                    <br />
                                    {(selectedOrder.order_details.recipient.address.address_2.length === 0) && <br />}
                                    {(selectedOrder.order_details.recipient.phone.length > 0) && <Icon name='phone' />}
                                    {(selectedOrder.order_details.recipient.phone.length > 0) && <a href={'tel:' + selectedOrder.order_details.recipient.phone}>{selectedOrder.order_details.recipient.phone}</a>}
                                </div>
                                )
                                : (<div>
                                    {selectedOrder.order_details.customer.name}<br />
                                    {selectedOrder.order_details.customer.address.address_1}<br />
                                    {(selectedOrder.order_details.customer.address.address_2.length > 0) && selectedOrder.order_details.customer.address.address_2}
                                    {(selectedOrder.order_details.customer.address.address_2.length > 0) && <br />}
                                    {selectedOrder.order_details.customer.address.postcode} {selectedOrder.order_details.customer.address.town_city}<br />
                                    {selectedOrder.order_details.customer.address.state}<br />
                                    {selectedOrder.order_details.customer.address.country}<br />
                                    <br />
                                    {(selectedOrder.order_details.customer.address.address_2.length === 0) && <br />}
                                    {(selectedOrder.order_details.customer.phone.length > 0) && <Icon name='phone' />}
                                    {(selectedOrder.order_details.customer.phone.length > 0) && <a href={'tel:' + selectedOrder.order_details.customer.phone}>{selectedOrder.order_details.customer.phone}</a>}
                                </div>
                                )
                            }
                        </Segment>
                    </Segment.Group>
                    <Segment>
                        <Accordion fluid>
                            <Accordion.Title active={cartOpen} onClick={this.handleCartClick.bind(this)}>
                                <Icon name='shopping bag' /><b>Order Details</b><Icon name='dropdown' />
                            </Accordion.Title>
                            <Accordion.Content active={cartOpen}>
                                <Table selectable style={{ wordBreak: 'break-word' }}>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell textAlign='left'>SKU</Table.HeaderCell>
                                            <Table.HeaderCell textAlign='left'>Description</Table.HeaderCell>
                                            <Table.HeaderCell textAlign='right'>Price</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {
                                            selectedOrder.order_details.items.map((item) => (
                                                <Table.Row key={item.id}>
                                                    <Table.Cell>{item.product}</Table.Cell>
                                                    <Table.Cell>
                                                        <Table celled>
                                                            <Table.Body>
                                                                {
                                                                    Object.keys(item.configurations).map(key => {
                                                                        let value = item.configurations[key];
                                                                        if (key === 'size') {
                                                                            value = (value.type) ? `${value.type}` : `${value.height} mm x ${value.width} mm`;
                                                                        } else if (key === 'weight') {
                                                                            value = `${value} KG`;
                                                                        }

                                                                        if (key.includes('path')) {
                                                                            return null;
                                                                        } else if (key.includes('download_url')) {              // Download URL checking needs to come first otherwise it will be filtered out by artwork keyword.
                                                                            return (
                                                                                <Table.Row key={key}>
                                                                                    <Table.Cell>{capitalizeKey(key)}</Table.Cell>
                                                                                    <Table.Cell><a href={(value.toLowerCase().includes('http')) ? value : 'http://' + value} target='_blank' download>{value}</a></Table.Cell>
                                                                                </Table.Row>
                                                                             )
                                                                        } else if (key.includes('artwork') || key.includes('jpeg_reference')) {
                                                                            let filePath = ( item.configurations[key + '_path']) == undefined ? filePath = "" : filePath = item.configurations[key + '_path'] ;
                                                                            console.log(filePath.includes('http'));
                                                                            return (
                                                                                <Table.Row key={key}>
                                                                                    <Table.Cell>{capitalizeKey(key)}</Table.Cell>
                                                                                    <Table.Cell><a href={filePath.includes('http') ? item.configurations[key + '_path'] : storageURI + item.configurations[key + '_path']} target='_blank' download>{value}</a></Table.Cell>
                                                                                </Table.Row>
                                                                            )
                                                                        }
                                                                         else {
                                                                            return (
                                                                                <Table.Row key={key}>
                                                                                    <Table.Cell>{capitalizeKey(key)}</Table.Cell>
                                                                                    <Table.Cell>{value}</Table.Cell>
                                                                                </Table.Row>
                                                                            )
                                                                        }
                                                                    })
                                                                }
                                                            </Table.Body>
                                                        </Table>
                                                    </Table.Cell>
                                                    <Table.Cell textAlign='right'>RM {item.price.toFixed(2)}</Table.Cell>
                                                </Table.Row>
                                            ))
                                        }
                                    </Table.Body>
                                    <Table.Footer>
                                        <Table.Row>
                                            <Table.HeaderCell></Table.HeaderCell>
                                            <Table.HeaderCell textAlign='right'>SUBTOTAL</Table.HeaderCell>
                                            <Table.HeaderCell textAlign='right'>RM {selectedOrder.order_details.subtotal.toFixed(2)}</Table.HeaderCell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.HeaderCell></Table.HeaderCell>
                                            <Table.HeaderCell textAlign='right'>SHIPPING ({selectedOrder.order_details.delivery_option})</Table.HeaderCell>
                                            <Table.HeaderCell textAlign='right'>RM {selectedOrder.order_details.shipping_fee.toFixed(2)}</Table.HeaderCell>
                                        </Table.Row>
                                        {(selectedOrder.order_details.shipping_disc > 0) &&
                                            (<Table.Row>
                                                <Table.HeaderCell></Table.HeaderCell>
                                                <Table.HeaderCell textAlign='right'>DISCOUNT (Shipping)</Table.HeaderCell>
                                                <Table.HeaderCell textAlign='right'>RM -{selectedOrder.order_details.shipping_disc.toFixed(2)}</Table.HeaderCell>
                                            </Table.Row>)
                                        }
                                        {(selectedOrder.order_details.voucher_code.length > 0) &&
                                            (<Table.Row>
                                                <Table.HeaderCell></Table.HeaderCell>
                                                <Table.HeaderCell textAlign='right'>VOUCHER DISCOUNT (Code: {selectedOrder.order_details.voucher_code})</Table.HeaderCell>
                                                <Table.HeaderCell textAlign='right'>RM -{selectedOrder.order_details.discount_amount.toFixed(2)}</Table.HeaderCell>
                                            </Table.Row>)
                                        }
                                        <Table.Row>
                                            <Table.HeaderCell></Table.HeaderCell>
                                            <Table.HeaderCell textAlign='right'><b>TOTAL</b></Table.HeaderCell>
                                            <Table.HeaderCell textAlign='right'><b>RM {selectedOrder.order_details.total_amount.toFixed(2)}</b></Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Footer>
                                </Table>
                            </Accordion.Content>
                        </Accordion>
                    </Segment>
                    <Segment>
                        <Icon name='tasks' /><b>Additional Information</b><br /><br />
                        {(selectedOrder.order_details.notes.length > 0) && <Message warning header='Customer Notes' size='small' content={selectedOrder.order_details.notes} />}
                        <Accordion fluid>
                            <Accordion.Title active={logOpen} onClick={this.handleLogClick.bind(this)}>
                                <Icon name='file text outline' /><b>Transaction Logs</b><Icon name='dropdown' />
                            </Accordion.Title>
                            <Accordion.Content active={logOpen}>
                                {this.renderLogs(selectedOrder)}
                            </Accordion.Content>
                        </Accordion>
                    </Segment>
                    {
                        ((selectedOrder.status !== 'Canceled') && (selectedOrder.status !== 'Shipped')) &&
                        <Segment textAlign='right'>
                            <Button icon='trash' content='Cancel Order' negative onClick={this.handleCancelOrder.bind(this)} />
                            <Button icon='cube' content='Process Order' primary onClick={this.handleProcessOrder.bind(this)} />
                        </Segment>
                    }
                </Segment.Group>
                <Modal size='small' open={addNoteDialog} onClose={this.closeAddNoteDialog.bind(this)} className='scrolling' closeIcon>
                    <Header icon='edit' content='Add Note' />
                    <Modal.Content>
                        <Form>
                            <Form.TextArea label='Note' value={miscNote} onChange={this.handleMiscNoteInput.bind(this)} />
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative onClick={this.closeAddNoteDialog.bind(this)} >
                            <Icon name='remove' /> Cancel
                        </Button>
                        <Button positive onClick={this.submitNote.bind(this)} disabled={miscNote.length === 0}>
                            <Icon name='checkmark' /> Submit
                        </Button>
                    </Modal.Actions>
                </Modal>
                <Modal open={processDialog} onClose={this.closeProcessDialog.bind(this)} className='scrolling' closeIcon>
                    <Header icon='cube' content='Process Order' />
                    <Modal.Content>
                        <Form>
                            <Form.Group>
                                <Form.Input fluid width={6} label='Payment Method' value={paymentMethod} readOnly />
                                <Form.Input action={{ content: 'Attach', icon: 'attach', onClick: () => this.bankslipUploader.click() }} fluid width={10} label='Payment Reference' value={paymentReference} onChange={this.handlePaymentRefInput.bind(this)} readOnly={paymentChecked} />
                                <input type="file" id="bank_slip" name="bank_slip" accept="image/*" ref={(ref) => this.bankslipUploader = ref} style={{ display: "none" }} onChange={(e) => { this.onBankslipUpload(e) }} disabled={paymentChecked} />
                            </Form.Group>
                            <Button primary icon='checkmark' content={(paymentChecked) ? 'Verified' : 'Verify'} disabled={(paymentMethod === '') || (paymentReference === '') || paymentChecked} onClick={this.verifyPayment.bind(this)} />
                        </Form>
                    </Modal.Content>
                    <Modal.Content>
                        <Form>
                            <Form.Group>
                                <Form.Select fluid width={6} label='Courier' options={courierOptions} value={shipmentCourier} disabled={!paymentChecked} onChange={this.handleCourierInput.bind(this)} />
                                <Form.Input fluid width={10} label='Tracking Number' value={shipmentTracking} disabled={!paymentChecked || (shipmentCourier === 'Self Collect')} onChange={this.handleTrackingInput.bind(this)} />
                            </Form.Group>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='send' content='Send Order' positive disabled={!enableSendButton} onClick={this.sendOrder.bind(this)} />
                    </Modal.Actions>
                </Modal>
                <Modal size='small' open={cancelDialog} closeOnEscape={false} closeOnRootNodeClick={false} onClose={this.closeCancelDialog.bind(this)} className='scrolling'>
                    <Header icon='trash' content='Cancel Order' />
                    <Modal.Content>
                        <p>Are you sure you want to CANCEL this order?</p>
                        <Form>
                            <Form.TextArea label='Cancellation Note' value={cancellationNote} placeholder='Please enter the reason for cancellation and refund status (if any) to proceed.' onChange={this.handleCancellationNoteInput.bind(this)} />
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative onClick={this.closeCancelDialog.bind(this)} >
                            <Icon name='remove' /> No
                        </Button>
                        <Button positive onClick={this.cancelOrder.bind(this)} disabled={cancellationNote.length === 0}>
                            <Icon name='checkmark' /> Yes
                        </Button>
                    </Modal.Actions>
                </Modal>
                <Modal open={upload_status !== 200} className='scrolling'>
                    <Modal.Header>Payment Slip Upload</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            {
                                (upload_status === 200)
                                    ? (<h4>Upload Successful! <br /></h4>)
                                    : (<h4>Uploading payment slip . . . </h4>)
                            }
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button positive={upload_status === 200} onClick={() => console.log('OK')} disabled={upload_status !== 200}>Close</Button>
                    </Modal.Actions>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = ({ order, auth, holiday }) => {
    return {
        order,
        user: {
            _id: auth.user._id,
            name: auth.user.name,
            email: auth.user.email
        },
        holiday
    }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        processOrder: processOrder,
        cancelOrder: cancelOrder,
        addNote: addNote,
        uploadBankSlip: uploadBankSlip,
        getHolidays:getHolidays,
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(OrderDetails);